export default __webpack_public_path__ + "static/media/sponsor-icon-bottom-nav-mobile.c47bdda2.webp";